import PaymentsIcon from "./PaymentsIcon";
import ExportsIcon from "./ExportsIcon";
import MovementsIcon from "./MovementsIcon";
import DetailsIcon from "./DetailsIcon";

export { PaymentsIcon, ExportsIcon, MovementsIcon, DetailsIcon };
